import {Box, Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import {PAPER_BACKGROUND} from "@/src/constant/constant";
import SuccessButton from "@/src/mui-custom/button/button-success";
import PrimaryButton from "@/src/mui-custom/button/button-primary";
import {usePathname} from "next/navigation";

const HeaderTitle = (props: any) => {
    const theme = useTheme();
    const pathname = usePathname();
    const isJournalPage = /^\/journals\/[^/]+$/.test(pathname.toString());

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: props.isFixed ? 'row' : 'column',
                alignItems: "flex-start",
                justifyContent: props.isFixed ? 'space-between' : "flex-start",
                paddingX: 1,
                paddingY: props.isFixed ? .7 : 1,
                background: "linear-gradient(0deg, #005f6b, #0c7f8b)",
                position: "relative",
                gap: 1,
                borderTopLeftRadius: theme.shape.borderRadius,
                borderTopRightRadius: theme.shape.borderRadius,
            }}
        >
            <Box
                sx={{
                    backgroundImage: `url(${PAPER_BACKGROUND})`,
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                    top: 0,
                    left: 0,
                }}
            />
            <Typography
                variant={!props.isFixed ? "fs1" : "fs5"}
                component={isJournalPage ? "h1" : "p"}
                sx={{
                    textShadow: "2px 2px 0 #0c7f8b",
                    color: "custom.teal",
                }}
            >{props.title}</Typography>
            {!props.isFixed && (
                <Typography
                    variant="fs6"
                    component="h2"
                    sx={{
                        color: "custom.teal",
                        fontWeight: 700,
                    }}
                >{props.subtitle}</Typography>
            )}
            {props.isFixed && (
                <Box sx={{display: "flex", alignItems: "center", gap: 1}}>
                    <SuccessButton
                        sx={{
                            borderRadius: ".75rem",
                            fontWeight: 700,
                            fontSize: ".9rem",
                            display: "flex",
                            alignItems: "center",
                            textShadow: 'none',
                            gap: 0.3,
                        }}
                        href={props.authorGuide.link ?? '#'}
                    >
                        <i className={props.authorGuide.icon}/>
                        {props.authorGuide.label}
                    </SuccessButton>
                    <PrimaryButton
                        sx={{
                            borderRadius: ".75rem",
                            fontWeight: 700,
                            fontSize: ".9rem",
                            display: "flex",
                            alignItems: "center",
                            textShadow: 'none',
                            gap: 0.3,
                        }}
                        href={props.submission.link ?? '#'}
                    >
                        <i className={props.submission.icon}/>
                        {props.submission.label}
                    </PrimaryButton>
                </Box>
            )}
        </Box>
    );
};

export default HeaderTitle;
